{
  "app": {
    "name": "Teach",
    "tagline": "Learn and teach, step by step."
  },
  "nav": {
    "home": "Home",
    "courses": "Courses",
    "skipToContent": "Skip to main content",
    "legal": "Legal information"
  },
  "home": {
    "heading": "The platform is up",
    "intro": "The technical foundation is running. Features land phase by phase.",
    "statusHeading": "API status",
    "roadmapHeading": "Next up",
    "roadmapBody": "Phase 1 — identity, authentication and permissions."
  },
  "api": {
    "version": "Version",
    "environment": "Environment",
    "locales": "Available languages",
    "reachable": "API reachable",
    "loading": "Contacting the API…",
    "retry": "Retry"
  },
  "errors": {
    "account_locked": "Too many attempts. Try again in a few minutes.",
    "account_unavailable": "This account is not available. Please contact support.",
    "bad_request": "The request is malformed.",
    "conflict": "This action conflicts with the current state.",
    "email_already_registered": "Account creation failed. Try signing in or resetting your password.",
    "entitlement_required": "This feature requires a higher plan.",
    "fresh_auth_required": "Confirm your password to continue.",
    "internal_error": "The server hit a problem. Our team has been notified.",
    "invalid_credentials": "Incorrect email address or password.",
    "invalid_refresh_token": "Your session has expired. Please sign in again.",
    "invalid_token": "This link is invalid or has expired.",
    "network_error": "Could not reach the server. Check your connection.",
    "no_deletion_pending": "No deletion is currently scheduled for this account.",
    "not_found": "This resource does not exist.",
    "permission_denied": "You do not have the required permissions.",
    "rate_limited": "Too many requests. Please wait a moment.",
    "requestId": "Reference: {{id}}",
    "role_not_self_assignable": "This role cannot be chosen at registration.",
    "session_not_found": "This session does not exist.",
    "title": "Something went wrong",
    "token_expired": "Your session has expired. Please sign in again.",
    "token_reuse_detected": "Your session was closed for security reasons. Please sign in again.",
    "unauthenticated": "You need to sign in to continue.",
    "unexpected_error": "An unexpected error occurred. Please try again shortly.",
    "validation_error": "Some fields are invalid.",
    "weak_password": "This password does not meet the security policy."
  },
  "notFound": {
    "heading": "Page not found",
    "body": "The link may be wrong, or the page has moved.",
    "backHome": "Back to home"
  },
  "pagination": {
    "shown_one": "{{count}} row shown",
    "shown_other": "{{count}} rows shown",
    "allShown": "end of list",
    "loadMore": "Load more",
    "loading": "Loading…"
  },
  "error": {
    "heading": "This screen could not be displayed",
    "body": "Something went wrong. Trying again usually fixes it; if the problem persists, send the technical detail below to support.",
    "retry": "Try again",
    "details": "Technical detail"
  },
  "richText": {
    "toolbar": "Formatting",
    "placeholder": "Write here…",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "strike": "Strikethrough",
    "code": "Inline code",
    "heading": "Heading level {{level}}",
    "bulletList": "Bullet list",
    "orderedList": "Numbered list",
    "blockquote": "Quote",
    "codeBlock": "Code block",
    "horizontalRule": "Divider",
    "align": {
      "left": "Align left",
      "center": "Align centre",
      "right": "Align right",
      "justify": "Justify"
    },
    "link": "Insert link",
    "unlink": "Remove link",
    "linkPrompt": "Link address (http, https or mailto)",
    "table": {
      "insert": "Insert table",
      "addRowBefore": "Insert row above",
      "addRowAfter": "Insert row below",
      "deleteRow": "Delete row",
      "addColumnBefore": "Insert column to the left",
      "addColumnAfter": "Insert column to the right",
      "deleteColumn": "Delete column",
      "toggleHeaderRow": "Header row",
      "mergeOrSplit": "Merge or split cells",
      "delete": "Delete table"
    },
    "undo": "Undo",
    "redo": "Redo"
  }
}
